var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tui-conversation",on:{"click":_setup.handleClickConv}},[_c(_setup.ConversationNetwork),_c(_setup.ConversationList,{on:{"handleSwitchConversation":_setup.handleSwitchConversation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }